import apiPaths from '../api-paths';

export default {
  index(query = '') {
    return axios.get(`${ apiPaths.BOOKKEEPING }/ksef/archived-purchase-invoices${ query }`);
  },

  unarchive(purchaseId) {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/ksef/archived-purchase-invoices/${ purchaseId }/unarchive`,
    );
  },

  batchUnarchive(invoiceIds) {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/ksef/archived-purchase-invoices/batch-unarchive`,
      {
        invoice_ids: invoiceIds,
      },
    );
  },
};
